import { type ObjectValuesUnionType } from '../../utils/typing';

export const UserActionTypes = Object.freeze({
  SET_CONNECTED: 'USER:SET_CONNECTED',
  SET_DISCONNECTED: 'USER:SET_DISCONNECTED',
  SET_FLAG_NEWUSER: 'USER:SET_FLAG_NEWUSER',
  SET_BANKROLL: 'USER:SET_BANKROLL',
  SET_REALMONEY: 'USER:SET_REALMONEY',
  SET_PREFERENCES: 'USER:SET_PREFERENCES',
  CLEAR_PREFERENCES: 'USER:CLEAR_PREFERENCES',
  SET_PRESETS: 'USER:SET_PRESETS',
  SET_CALENDAR_HOUR_PREFERENCE: 'USER:SET_CALENDAR_HOUR_PREFERENCE',
  SET_MESSAGES: 'USER:SET_MESSAGES',
  SET_MUST_VALIDATE_EVENTS: 'USER:SET_MUST_VALIDATE_EVENTS',
  SET_MUST_VALIDATE_CGU: 'USER:SET_MUST_VALIDATE_CGU',
  ACK_MESSAGE: 'USER:ACK_MESSAGE',
  SET_NICKNAME: 'USER:SET_NICKNAME',
  SET_CONNECTING: 'USER:SET_CONNECTING',
  SET_LAST_SESSION_SETTLED_BETS: 'USER:SET_LAST_SESSION_SETTLED_BETS',
  CLEAR_LAST_SESSION_SETTLED_BETS: 'USER:CLEAR_LAST_SESSION_SETTLED_BETS',
  SET_EMBEDDED_NOTIFICATION_TARGET: 'USER:SET_EMBEDDED_NOTIFICATION_TARGET',
  SET_AFFILIATION: 'USER:SET_AFFILIATION',
  SET_MILES: 'USER:SET_MILES',
  SET_BONUSES: 'USER:SET_BONUSES',
  GET_USER_DATA_KO: 'USER:GET_USER_DATA_KO',
  SET_CC: 'USER:SET_CC',
  SET_SESSIONID: 'USER:SET_SESSIONID',
  SET_TICKETS: 'USER:SET_TICKETS',
  SET_DID_RECEIVED_DATA: 'USER:SET_DID_RECEIVED_DATA',
  SET_MISSIONS_MODERATOR: 'USER:SET_MISSIONS_MODERATOR',
  SET_PROMOTION_STATUS: 'USER:SET_PROMOTION_STATUS',
  TOGGLE_OPTION_DISPLAY_SLIDERS: 'USER:TOGGLE_OPTION_DISPLAY_SLIDERS',
});

export type UserActionType = ObjectValuesUnionType<typeof UserActionTypes>;
